module.exports = __webpack_public_path__ + "img/s4-5.96167abc.jpg";